import React, { FC } from 'react'
import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined } from '@ant-design/icons'
import { Row, Col, Tooltip } from 'antd'

interface ControlProps {
  instance: any
}
type ControlType = 'up' | 'down' | 'delete'
const Control: FC<ControlProps> = ({ instance }) => {
  const handlerControl = (type: ControlType) => {
    const activeObject = instance?.getActiveObject()
    if (activeObject) {
      switch (type) {
        case 'delete':
          instance.remove(activeObject)
          break
        case 'down':
          activeObject.bringForward()
          break
        case 'up':
          activeObject.sendBackwards()
          break
      }
    }
  }
  return (
    <Row>
      <Col offset={3} style={{ marginBottom: 10 }}>
        <span>操作:</span>
      </Col>
      <Col span={2}>
        <Tooltip title="图层上移">
          <ArrowUpOutlined onClick={() => handlerControl('down')} />
        </Tooltip>
      </Col>
      <Col span={2}>
        <Tooltip title="图层下移">
          <ArrowDownOutlined onClick={() => handlerControl('up')} />
        </Tooltip>
      </Col>
      <Col span={2}>
        <Tooltip title="删除图层">
          <DeleteOutlined onClick={() => handlerControl('delete')} />
        </Tooltip>
      </Col>
    </Row>
  )
}

export default Control
